
import { OrderLine } from "@/utils/peppol/order-line";
import { roundDecimalsAdvanced } from "@/utils/numbers";
import Vue from "vue";

export default Vue.extend({
	props: {
		line: {
			type: Object as ()=>OrderLine,
			required: true
		}
	},
	computed: {
		formatDiscount(): string {
			if (this.line.ReductionPercentage > 0) {
				return `-${this.formatNumber(this.line.ReductionPercentage)}%`;
			}
			if (this.line.ReductionAmount > 0) {
				return `-${this.formatNumber(this.line.ReductionAmount)}`;
			}
			return "";
		}
	},
	methods: {
		formatNumber(value: number): string {
			return roundDecimalsAdvanced(value, {
				decimals: 2,
				decimalSeperator: ",",
				thousandsSeperator: ".",
				thousandSeperatorInterval: 3
			});
		}
	}
});
